import styles from './CarriersGridSection.module.scss';

import React from 'react';
import RetinaImage from 'src/components/RetinaImage';
import { Container, Row, Col } from 'reactstrap';
import {
  ScrollOverPack,
  TweenOne,
  FadeUp,
  FadeIn
} from 'src/components/Animations';

import LogoCanadaPost from 'src/images/logo-canada-post.png';
import LogoCanadaPost2x from 'src/images/logo-canada-post@2x.png';
import LogoCanadaPost3x from 'src/images/logo-canada-post@3x.png';
import LogoDHLEcommerce from 'src/images/logo-dhl-ecommerce.png';
import LogoDHLEcommerce2x from 'src/images/logo-dhl-ecommerce@2x.png';
import LogoDHLEcommerce3x from 'src/images/logo-dhl-ecommerce@3x.png';
import LogoDHLExpress from 'src/images/logo-dhl-express.png';
import LogoDHLExpress2x from 'src/images/logo-dhl-express@2x.png';
import LogoDHLExpress3x from 'src/images/logo-dhl-express@3x.png';
import LogoFedEx from 'src/images/logo-fedex.png';
import LogoFedEx2x from 'src/images/logo-fedex@2x.png';
import LogoFedEx3x from 'src/images/logo-fedex@3x.png';
import LogoFirstMile from 'src/images/logo-first-mile.png';
import LogoFirstMile2x from 'src/images/logo-first-mile@2x.png';
import LogoLasership from 'src/images/logo-lasership.png';
import LogoLasership2x from 'src/images/logo-lasership@2x.png';
import LogoLasership3x from 'src/images/logo-lasership@3x.png';
import LogoNewgistics from 'src/images/logo-newgistics.png';
import LogoNewgistics2x from 'src/images/logo-newgistics@2x.png';
import LogoNewgistics3x from 'src/images/logo-newgistics@3x.png';
import LogoOnTrac from 'src/images/logo-ontrac.png';
import LogoOnTrac2x from 'src/images/logo-ontrac@2x.png';
import LogoOnTrac3x from 'src/images/logo-ontrac@3x.png';
import LogoOSMWorldwide from 'src/images/logo-osm-worldwide.png';
import LogoOSMWorldwide2x from 'src/images/logo-osm-worldwide@2x.png';
import LogoOSMWorldwide3x from 'src/images/logo-osm-worldwide@3x.png';
import LogoPostageOne from 'src/images/logo-postage-one.png';
import LogoPostageOne2x from 'src/images/logo-postage-one@2x.png';
import LogoUPS from 'src/images/logo-ups.png';
import LogoUPS2x from 'src/images/logo-ups@2x.png';
import LogoUPS3x from 'src/images/logo-ups@3x.png';
import LogoUSPS from 'src/images/logo-usps.png';
import LogoUSPS2x from 'src/images/logo-usps@2x.png';
import LogoUSPS3x from 'src/images/logo-usps@3x.png';

export default (props) => (
  <ScrollOverPack {...props}
                  className={props.className}
                  styleName='carriers-grid-section'>
      <TweenOne key='0' component={Container} {...FadeIn}>
          <div className='h2'>
              Galleon supports carriers from here to anywhere
          </div>
          <div key='subheading' className='h2 text-blue'>
              And we’re adding more.
          </div>
      </TweenOne>
      <TweenOne key='1' component={Container} styleName='logos-table' {...FadeUp}>
          <Row>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoUPS, LogoUPS2x, LogoUPS3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoFedEx, LogoFedEx2x, LogoFedEx3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoUSPS, LogoUSPS2x, LogoUSPS3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoDHLEcommerce, LogoDHLEcommerce2x, LogoDHLEcommerce3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoDHLExpress, LogoDHLExpress2x, LogoDHLExpress3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoNewgistics, LogoNewgistics2x, LogoNewgistics3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoOnTrac, LogoOnTrac2x, LogoOnTrac3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoCanadaPost, LogoCanadaPost2x, LogoCanadaPost3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoPostageOne, LogoPostageOne2x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoFirstMile, LogoFirstMile2x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoLasership, LogoLasership2x, LogoLasership3x]} />
              </Col>
              <Col styleName='logo-cell' lg='4' md='6' xs='12'>
                  <RetinaImage srcSet={[LogoOSMWorldwide, LogoOSMWorldwide2x, LogoOSMWorldwide3x]} />
              </Col>
          </Row>
      </TweenOne>
      <TweenOne key='disclaimer-container'
                component={Container}
                styleName='disclaimer-container'
                {...FadeUp}>
          <p>
              All company logos above are trademarks (&trade;) or registered
              trademarks (&reg;) of their respective holders.
          </p>
          <p>
              Use of these logos does not imply any affiliation with or
              endorsement by them.
          </p>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/CarriersGridSection.js